import { useEffect, useState } from "react";
import { Country } from "../../../utils/database";
import useToken from "../../auth/useToken";
import { countriesService } from "../../../services/administration/countriesService";


interface Props {}

export default function useCountries({}: Props) {
  const [countries, setCountries] = useState<Country[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>();
  const { token } = useToken();
  /**
   * Récupération des countrys avec filtres (provenant des props)
   */
  const createCountry = async (newCountry: Country) => {
    try {
      await countriesService.createCountry(newCountry);
    } catch (error) {
      throw error;
    }
  };
  const getCountries = async () => {
    setLoading(true);
    try {
      const countriesData = await countriesService.getCountries(100, 0);
      setCountries(countriesData);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setError(error);
      setLoading(false);
    }
  };

  const deleteCountry = async (countryId: string) => {
    try {
      await countriesService.deleteCountry(countryId);
      getCountries();
    } catch (error) {
      console.error(error);
      setError(error);
    }
  };

  const updateCountry = async (updatedCountry: Country) => {
    if (!updatedCountry.id) {
      alert("Une erreur s'est produite");
      return;
    }
    try {
      await countriesService.updateCountry(updatedCountry);
      getCountries();
    } catch (error) {
      console.error(error);
      setError(error);
    }
  };

  /**
   * Recharger les countrys quand les filtres changent
   */
  useEffect(() => {
    getCountries();
  }, [token]);

  return {
    countries,
    getCountries,
    length: countries.length,
    countriesLoading: loading,
    countriesError: error,
    deleteCountry,
    updateCountry,
    createCountry,
  };
}
